import React, { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ClientConfigContext } from '../../../config/clientConfig';

const useStyles = makeStyles(() =>
    createStyles({
        logo: {
            height: '50px',
            width: 'auto',
            objectFit: 'contain',
        },
        title: {
            margin: '0 28px 0 10px',
        },
    }),
);

function Banner() {
    const { title, theming } = useContext(ClientConfigContext);
    const classes = useStyles();

    return (
        <Grid container item alignItems='center' direction='row' md={5} sm={6} xs={8}>
            <img src={theming.logoUri} alt={theming.logoAltText} className={classes.logo} />
            <Typography variant='h5' className={classes.title}>
                {title}
            </Typography>
        </Grid>
    );
}

export default Banner;
